import { useUserStore } from 'src/stores/user-store'
import { useMenuStore, MenuItem } from 'src/stores/menu-store'

// Mapeamento de rotas para permissões necessárias
const routePermissionMap: Record<string, string[]> = {
  // Home
  '/dashboard': ['dashboard'],

  // Workflows
  '/workflows': ['home-workflow'],
  '/workflows/types': ['home-workflow-types'],
  '/workflows/groups': ['home-workflow-groups'],
  '/workflows/create': ['home-workflow'],
  '/workflows/delegate': ['home-workflow'],

  // Users (Access Control)
  '/users': ['home-access_control-user'],
  '/users/create': ['home-access_control-user'],
  '/users/clone': ['home-access_control-user'],
  '/users/:id/profiles': ['home-access_control-user'],
  '/users/:id/profiles/create': ['home-access_control-user'],
  '/users/:id/profiles/:profileId/permission': ['home-access_control-user'],
  '/users/:id/profiles/:profileId/companies': ['home-access_control-user'],
  '/users/:id/profiles/:profileId/sales-offices': ['home-access_control-user'],
  '/users/:id/profiles/:profileId/business-partners': [
    'home-access_control-user',
  ],
  '/users/:id/profiles/:profileId/workflow-types': ['home-access_control-user'],

  // Commercial
  '/case-management': ['commercial-case-case_management'],
  '/case-management/sla': ['commercial-case-sla'],
  '/case-management/office-hours': ['commercial-case-business'],
  '/claim': ['commercial-claims-global_claim'],
  '/price/automotive': ['pricing-automotive-automotive_table_configuration'],
  '/price/industrial': ['pricing-industrial-industrial_table_configuration'],
  '/price/automotive/positioning': [
    'pricing-automotive-automotive_placement_configuration',
  ],
  '/price/automotive/discount-exception': [
    'pricing-automotive-automotive_settings_up_exceptions_or_discounts',
  ],
  '/price/industrial/positioning-cube': [
    'pricing-industrial-industrial_position_configuration',
  ],
  '/price/industrial/group': [
    'pricing-industrial-industrial_group_configuration',
  ],
  '/price/material-exception-by-channel': [
    'pricing-others-others_material_exception_by_channel',
  ],
  '/price/import': [
    'pricing-others-others_import'
  ],
  '/business-partner': ['commercial-partner-business_partner_business_partner'],
  '/business-partner/automotive-discount': [
    'commercial-partner-business_partner_automotive_discount',
  ],
  '/business-partner/mass-update': [
    'commercial-partner-business_partner_bulk_update',
  ],
  '/edi/client/packaging': [
    'commercial-partner-business_partner_bulk_update', //TODO: alterar para permissão correta
  ],
  '/edi/partner-location': [
    'commercial-partner-business_partner_bulk_update',//TODO: alterar para permissão correta
  ],
  '/contracts': ['commercial-contract-contract_list'],
  '/contracts-report': ['commercial-sales-contract_report'],
  '/my-orders': ['commercial-sales_order-my_orders'],
  '/create-europe-hana': ['commercial-sales_order-hana'],
  '/internal-china/create': ['commercial-sales_order-china'],
  '/internal-india/create': ['commercial-sales_order-india'],
  '/internal-brazil/create': ['commercial-sales_order-brazil'],
  '/internal-brazil/update/:id': ['commercial-sales_order-brazil'],
  '/internal-brazil/details/:id': ['commercial-sales_order-brazil'],
  '/internal-brazil/release/:id': ['commercial-sales_order-brazil'],
  '/internal-argentina/create': ['commercial-sales_order-argentina'],
  '/internal-argentina/update': ['commercial-sales_order-argentina'],
  '/internal-argentina/details': ['commercial-sales_order-argentina'],
  '/internal-argentina/release': ['commercial-sales_order-argentina'],
  '/internal-europe/create': ['commercial-sales_order-hana'],
  '/my-orders/internal-europe': [
    'commercial-sales_order-my_orders',
    'commercial-sales_order-hana',
  ],
  '/my-orders/internal-china': [
    'commercial-sales_order-my_orders',
    'commercial-sales_order-china',
  ],
  '/my-orders/internal-india': [
    'commercial-sales_order-my_orders',
    'commercial-sales_order-india',
  ],

  // Reports
  '/sales-report': ['sales'],
  '/sales-report-682': ['commercial-sales-report_682'],
  '/sales-performance-report': ['commercial-sales-sales_perfomance_report'],
  '/broker-commission': ['commercial-sales-broke_comission_report'],
  '/reporting-tool': ['commercial-sales-bi_report'],

  // Financial
  '/open-invoices': ['financial-invoicesopen_invoices'],
  '/open-invoices-grouped': ['financial-invoices-open_invoices_grouped'],
  '/cost-accounting': ['financial-cost-accounting'],
  '/managerial-cost': ['financial-cost-managerial'],
  '/credit-limit': ['financial-credit_limit-request'],

  // IT
  '/import-infocentre': ['it-import-import_infocenter'],

  // Tools
  '/tools-reports': ['tools-reports'],
  '/tools-reports/open-invoices': ['tools-reports-open_invoices'],
  '/tools-reports/purchase-orders': ['tools-reports-purchase_orders'],

  // Master Data - Business Partner
  '/common/crud-account-group': ['master_data-business_partner-account_group'],
  '/common/crud-business-partner-role': [
    'master_data-business_partner-business_partner_role',
  ],
  '/common/crud-channel': ['master_data-business_partner-channel'],
  '/common/crud-customer-tiering-tier': [
    'master_data-business_partner-customer_tiering_tier',
  ],
  '/common/crud-distribution-channel': [
    'master_data-business_partner-distribution_channel',
  ],
  '/common/crud-sales-area': ['master_data-business_partner-sales_area'],
  '/common/crud-sales-district': [
    'master_data-business_partner-sales_district',
  ],
  '/common/crud-sales-group': ['master_data-business_partner-sales_group'],
  '/common/crud-sales-office': ['master_data-business_partner-sales_office'],
  '/common/crud-sales-organization': [
    'master_data-business_partner-sales_organization',
  ],
  '/common/crud-currency': ['master_data-common-currency'],

  // Master Data - Material
  '/common/crud-deposit': ['master_data-material-deposit'],
  '/common/crud-material-hierarchy-first-level': [
    'master_data-material-material_hierarchy_first_level',
  ],
  '/common/crud-material-hierarchy-second-level': [
    'master_data-material-material_hierarchy_second_level',
  ],
  '/common/crud-material-hierarchy-third-level': [
    'master_data-material-material_hierarchy_third_level',
  ],
  '/common/crud-material-hierarchy-fourth-level': [
    'master_data-material-material_hierarchy_fourth_level',
  ],
  '/common/crud-material-hierarchy-fifth-level': [
    'master_data-material-material_hierarchy_fifth_level',
  ],
  '/common/crud-material-hierarchy-sixth-level': [
    'master_data-material-material_hierarchy_sixth_level',
  ],
  '/common/crud-material-hierarchy-seventh-level': [
    'master_data-material-material_hierarchy_seventh_level',
  ],
  '/common/crud-material-simp': ['master_data-material-material_simp'],
  '/common/crud-material-type': ['master_data-material-material_type'],
  '/common/crud-tier': ['master_data-material-tier'],

  // Orders
  '/orders/my-purchase-orders': ['orders-my_purchase_orders-purchase_orders'],
  '/orders/b2b-asia': ['orders-my_purchase_orders-b2b_asia'],
  '/orders/b2b-europe': ['orders-my_purchase_orders-b2b_europe'],
  '/orders/b2b-india': ['orders-my_purchase_orders-b2b_india'],
  '/orders/b2b-hyundai': ['orders-my_purchase_orders-b2b_hyundai'],
  '/orders/b2b-argentina': ['orders-my_purchase_orders-b2b_argentina'],

  //EDI
  '/edi/sku-client': ['orders-my_purchase_orders-purchase_orders'], // TODO: Alterar para permissão quando vier do back
  '/edi/sku-client/create': ['orders-my_purchase_orders-purchase_orders'], // TODO: Alterar para permissão quando vier do back
  '/edi/client-file-name': ['orders-my_purchase_orders-purchase_orders'], // TODO: Alterar para permissão quando vier do back
  '/edi/client/file-name': ['orders-my_purchase_orders-purchase_orders'], // TODO: Alterar para permissão quando vier do back
  '/edi/client/file-name/create': ['orders-my_purchase_orders-purchase_orders'], // TODO: Alterar para permissão quando vier do back
  '/edi/sku-edi': ['orders-my_purchase_orders-purchase_orders'], // TODO: Alterar para permissão quando vier do back
  '/edi/ref-number': ['orders-my_purchase_orders-purchase_orders'], // TODO: Alterar para permissão quando vier do back
  '/edi/ref-number/create': ['orders-my_purchase_orders-purchase_orders'], //TODO: alterar para permissão correta

  // SGQ
  '/sgq/document-management': ['orders-my_purchase_orders-purchase_orders'],//TODO: alterar permissão
}

const normalizeRoute = (route: string): string => {
  return route
    .replace(
      /\/[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}/g,
      ''
    ) // Remove UUIDs primeiro
    .replace(/\/:\w+/g, '') // Remove parâmetros como :id, :profileId
    .replace(/\/\d+/g, '') // Remove números simples
    .replace(/\?.*$/, '') // Remove query parameters
}

const matchesRoutePattern = (
  currentRoute: string,
  patternRoute: string
): boolean => {
  const normalizedCurrent = normalizeRoute(currentRoute)
  const normalizedPattern = normalizeRoute(patternRoute)

  if (normalizedCurrent === normalizedPattern) return true
  if (normalizedCurrent.startsWith(normalizedPattern + '/')) return true

  return false
}

const getRequiredPermissions = (route: string): string[] => {
  if (routePermissionMap[route]) {
    return routePermissionMap[route]
  }

  // Busca por padrões que fazem match com a rota atual
  let bestMatch = ''
  let bestPermissions: string[] = []

  for (const [pattern, permissions] of Object.entries(routePermissionMap)) {
    if (matchesRoutePattern(route, pattern)) {
      if (pattern.length > bestMatch.length) {
        bestMatch = pattern
        bestPermissions = permissions
      }
    }
  }

  if (bestMatch) {
    return bestPermissions
  }

  // Verifica se a rota começa com /my-orders/ e busca por padrão sem o prefixo
  if (route.startsWith('/my-orders/')) {
    const routeWithoutPrefix = route.replace('/my-orders', '')
    if (routePermissionMap[routeWithoutPrefix]) {
      return routePermissionMap[routeWithoutPrefix]
    }

    // Também verifica padrões que fazem match sem o prefixo
    for (const [pattern, permissions] of Object.entries(routePermissionMap)) {
      if (matchesRoutePattern(routeWithoutPrefix, pattern)) {
        if (pattern.length > bestMatch.length) {
          bestMatch = pattern
          bestPermissions = permissions
        }
      }
    }

    if (bestMatch) {
      return bestPermissions
    }
  }

  if (route.startsWith('/common/')) {
    const crudName = route.split('/')[2]
    const baseRoute = `/common/${crudName}`
    if (routePermissionMap[baseRoute]) {
      return routePermissionMap[baseRoute]
    }
  }

  return []
}

const getAllPermissions = (items: MenuItem[]): string[] => {
  const permissions: string[] = []

  items.forEach((item: MenuItem) => {
    permissions.push(item.Description)
    if (item.Children && item.Children.length > 0) {
      permissions.push(...getAllPermissions(item.Children))
    }
  })

  return permissions
}

export const useRoutePermissions = () => {
  const user = useUserStore((state) => state.user)
  const menuItems = useMenuStore((state) => state.items)

  const hasAccessToRoute = (route: string): boolean => {
    if (!user) {
      return false
    }

    const publicRoutes = [
      '/',
      '/new-password',
      '/password-recovery',
      '/dashboard',
    ]
    if (publicRoutes.includes(route)) {
      return true
    }

    const requiredPermissions = getRequiredPermissions(route)
    if (requiredPermissions.length === 0) {
      return false
    }

    const allUserPermissions = getAllPermissions(menuItems || [])

    const hasAccess = requiredPermissions.every((permission) =>
      allUserPermissions.includes(permission)
    )

    return hasAccess
  }

  const hasPermission = (permission: string): boolean => {
    if (!user) return false
    const allUserPermissions = getAllPermissions(menuItems || [])
    return allUserPermissions.includes(permission)
  }

  const hasAllPermissions = (permissions: string[]): boolean => {
    if (!user) return false
    const allUserPermissions = getAllPermissions(menuItems || [])
    return permissions.every((permission) =>
      allUserPermissions.includes(permission)
    )
  }

  const hasAnyPermission = (permissions: string[]): boolean => {
    if (!user) return false
    const allUserPermissions = getAllPermissions(menuItems || [])
    return permissions.some((permission) =>
      allUserPermissions.includes(permission)
    )
  }

  const getUserPermissions = (): string[] => {
    if (!user) return []
    return getAllPermissions(menuItems || [])
  }

  return {
    hasAccessToRoute,
    hasPermission,
    hasAllPermissions,
    hasAnyPermission,
    getUserPermissions,
  }
}

export const addRoutePermission = (route: string, permissions: string[]) => {
  routePermissionMap[route] = permissions
}

export const removeRoutePermission = (route: string) => {
  delete routePermissionMap[route]
}

export const getAllMappedRoutes = () => {
  return Object.keys(routePermissionMap)
}

export const getRoutePermissions = (route: string) => {
  return getRequiredPermissions(route)
}
